var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'logout' }}},[_c('Button',{attrs:{"type":"secondary"}},[_vm._v(_vm._s(_vm.$t('common.logout')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }